import * as Yup from 'yup';

export const PAGE_SIZE_LIST = 12;

export const PAGE_SIZE_IMAGE = 1000;

export const messageToastType_const = {
  error: 'error',
  warning: 'warning',
  info: 'info',
  success: 'success'
};

export const roleName_const = [
  'Kỹ thuật',
  'Giám đốc',
  'Quản lý',
  'Kế toán',
  'Nhân viên Sale',
  'Đại lý',
  'Khách hàng'
];

export const DEVICE_STATUS_FILTER = [
  { value: 'active', name: 'Kích hoạt' },
  { value: 'inactive', name: 'Lưu kho' },
  { value: 'warranty', name: 'Bảo hành' }
];

export const SERVICE_SUB_FILTER = [
  { value: '0', name: 'Hết hạn' },
  { value: '10', name: '10 Ngày' },
  { value: '20', name: '20 Ngày' },
  { value: '25', name: '25 Ngày' },
  { value: '30', name: '30 Ngày' }
];

export const userShape_const = {
  email: Yup.string()
    .email('Email chưa đúng định dạng')
    .max(255)
    .required('Bạn cần nhập Email'),
  full_name: Yup.string()
    .min(2, 'Tên quá ngắn')
    .max(50, 'Tên quá dài')
    .required('Bạn cần nhập đầy đủ họ tên'),
  phone: Yup.string()
    .matches(new RegExp('^[0-9-+]{9,11}$'), 'Số điện thoại phải đúng định dạng')
    .required('Bạn cần nhập số điện thoại'),
  password: Yup.string()
    .min(4, 'Quá ngắn')
    .max(20, 'Quá dài')
    .required('Bạn cần nhập mật khẩu'),
  address: Yup.string()
    .max(100, 'Quá dài')
    .required('Bạn cần điền địa chỉ')
  // dob: Yup.date().required('Bạn cần chọn ngày sinh')
};

export const DRAFT_USER = { id: 3, value: 'Bản Nháp' };

export const STATUS_API = {
  PENDING: 0,
  SUCCESS: 1,
  ERROR: 2,
  LOADING: 3
};

export const DEVICE_STATUS_VALUE = [
  { id: 1, title: 'Lưu kho' },
  { id: 2, title: 'Bảo hành' }
];

export const DEVICE_STATUS = {
  STORAGE: 1,
  GUARANTEE: 2,
  INACTIVE: 'inactive',
  ACTIVE: 'active',
  WARRANTY: 'warranty',
};
export const AGENCY_STATUS = {
  INACTIVE: 'inactive',
  ACTIVE: 'active'
};

export const STORE_STATUS = {
  IN: 'in',
  SELL: 'sell'
};

export const ACTION_TABLE = {
  CREATE: 'create',
  ACTIVE: 'active',
  EDIT: 'edit',
  PREVIEW: 'preview',
  DELETE: 'delete'
};

export const MEDIA_VIEW_TYPE = {
  IMAGES: 0,
  VIDEOS: 1
};
export const HTTP_GETTYPE = {
  ALL: 0,
  ALL_PAGINATION: 1,
  DETAIL: 2
};
export const TIMEOUT_DEFAULT = 10000;
export const MSG_TIMEOUT_REQUEST = 'Server phản hồi quá lâu , vui lòng thử lại';
export const CREATE_DEVICE_STEP = {
  ADD_INFO_DEVICE: 1,
  ADD_INFO_VEHICLE: 2
};
//tuando
export const ACTIVE_DEVICE_STEP = {
  ACTIVE_INFO_DEVICE: 1,
  ACTIVE_INFO_VEHICLE: 2
};

export const VEHICLE_STATUS = {
  ACTIVE: 'active',
  NOT_ACTIVE: 'not_active'
};
export const VALIDATE = {
  PHONE: /^((84|0)[3|5|7|8|9])+([0-9]{8})$/,
  PEOPLE_ID: /^(((0[1-9]|3[0-8])[0-9]{7})|(([1-2][0-9]|3[0-8])[0-9]{7})|([0-9]{12}))$/
};

export const CAR_STATUS = [
  {
    value: 'moving',
    label: 'Di chuyển',
    icon: 'car_moving',
    info: 'Phương tiện đang di chuyển'
  },
  {
    value: 'stopped',
    label: 'Dừng đỗ',
    icon: 'car_stopped',
    info: 'Phương tiện dừng đỗ hoặc tắt máy'
  },
  {
    value: 'over_speed',
    label: 'Quá tốc độ',
    icon: 'car_out_speed',
    info: 'Phương tiện di chuyển quá tốc độ'
  },
  {
    value: 'lost_gps',
    label: 'Mất GPS',
    icon: 'car_lost_gps',
    info: 'Phương tiện mất tín hiệu GPS'
  },
  {
    value: 'lost_gsm',
    label: 'Mất 4G',
    icon: 'car_lost_gsm',
    info: 'Phương tiện mất tín hiệu liên lạc (4G/GPRS)'
  }
];

export const INFOR_CAR = [
  [
    {
      icon: 'car',
      label: 'Biển số',
      dataKey: 'license_plate',
      exampleValue: '30H99888'
    },
    {
      icon: 'user',
      label: 'Tên gợi nhớ',
      dataKey: 'custom_name',
      exampleValue: 'Tên gợi nhớ'
    },
    {
      icon: 'clock',
      label: 'Thời gian',
      dataKey: 'created_at',
      exampleValue: '20:45 30/04/2021'
    },
    {
      icon: 'pin',
      label: 'Tọa độ',
      dataKey: 'coordinates',
      exampleValue: '21.028511, 105.804817'
    },
    {
      icon: 'pin',
      label: 'Địa chỉ',
      dataKey: 'location',
      exampleValue: '7 Hồ Thiền Quang, Nguyễn Du, Hai Bà Trưng, Hà Nội'
    },
    {
      icon: 'speedometer2',
      label: 'Vận tốc',
      dataKey: 'speed_gps',
      exampleValue: '0 km/h'
    },
    {
      icon: 'direction',
      label: 'Km trong ngày',
      dataKey: 'daily_distance',
      exampleValue: '500 km'
    },
    {
      icon: 'direction',
      label: 'Km tích lũy',
      dataKey: 'total_distance',
      exampleValue: '5000 km'
    },
    {
      icon: 'parked',
      label: 'Thời gian dừng đỗ',
      dataKey: 'stop_duration',
      exampleValue: '03h23p'
    },
    {
      icon: 'engine',
      label: 'Động cơ',
      dataKey: 'engine_status',
      exampleValue: 'Bật'
    },
    {
      icon: 'battery',
      label: 'Điện áp',
      dataKey: 'battery',
      exampleValue: '12.5 V'
    },
    {
      icon: 'device',
      label: 'Cảm biến nhiên liệu:',
      dataKey: 'activity_chart',
      exampleValue: ''
    }
  ],
  [
    {
      icon: 'device',
      label: 'Loại thiết bị',
      dataKey: 'device_type',
      exampleValue: ''
    },
    {
      icon: 'serial',
      label: 'Serial thiết bị',
      dataKey: 'serial',
      exampleValue: 'ABC123'
    },
    {
      icon: 'fw_version',
      label: 'Phiên bản HW / FW',
      dataKey: 'firmware_version',
      exampleValue: '1.0.0'
    },
    {
      icon: 'save',
      label: 'Imei sim',
      dataKey: 'imei_sim',
      exampleValue: '0989982456'
    },
    {
      icon: 'phone',
      label: 'SĐT Sim',
      dataKey: 'sim',
      exampleValue: '0989982456'
    },
    {
      icon: 'network',
      label: 'Nhà mạng',
      dataKey: 'network_operator',
      exampleValue: 'Vinaphone'
    },
    {
      icon: 'register_package_day',
      label: 'Ngày kích hoạt',
      dataKey: 'active_at',
      exampleValue: '13/07/2023'
    },
    {
      icon: 'user',
      label: 'Tên đại lý',
      dataKey: 'agency_name',
      exampleValue: 'Vntech24h'
    },
    {
      icon: 'oil_sensor',
      label: 'Giá trị CB nhiên liệu',
      dataKey: 'fuel_sensor_val'
    },
    {
      icon: 'save',
      label: 'Bộ nhớ',
      dataKey: 'memory_card',
      // Dung lượng còn trống lấy từ trường 273 của bản tin; -1 hiện thành "Lỗi bộ nhớ".
      // Xem popupInfocar/memoryStatus.js.
      exampleValue: '11.7 GB'
    },
    {
      icon: 'level',
      label: '4G signal / Vệ tinh',
      dataKey: 'gsm_level',
      exampleValue: '3'
    },
  ],
  [
    {
      icon: 'user',
      label: 'Lái xe',
      dataKey: 'driver_name',
      exampleValue: 'Vntech24h'
    },
    {
      icon: 'payments',
      label: 'Bằng lái',
      dataKey: 'driver_license',
      exampleValue: 'B2'
    },
    {
      icon: 'phone',
      label: 'Điện thoại',
      dataKey: 'driver_phone',
      exampleValue: '0989982456'
    },
    {
      icon: 'time2',
      label: 'Thời gian lái xe liên tục',
      dataKey: 'non_stop_driving_time',
      exampleValue: ''
    },
    {
      icon: 'maxSpeed',
      label: 'Vận tốc tối đa',
      dataKey: 'max_speed',
      exampleValue: '0 km/h'
    },
    {
      icon: 'speedometer3',
      label: 'Quá tốc độ',
      dataKey: 'total_overspeed',
      exampleValue: '0 lần'
    },
    {
      icon: 'parked2',
      label: 'Số lần dừng đỗ',
      dataKey: 'stop_times',
      exampleValue: '40 lần'
    },
    {
      icon: 'iconSettingActive',
      label: 'Tích truyền',
      dataKey: 'status_transmission',
      exampleValue: 'Bật'
    }
  ]
];

export const INFOR_MOTO = [
  [
    {
      icon: 'car',
      label: 'Biển số',
      dataKey: 'license_plate',
      exampleValue: '30H99888'
    },
    {
      icon: 'user',
      label: 'Tên gợi nhớ',
      dataKey: 'custom_name',
      exampleValue: 'Tên gợi nhớ'
    },
    {
      icon: 'clock',
      label: 'Thời gian',
      dataKey: 'created_at',
      exampleValue: '20:45 30/04/2021'
    },
    {
      icon: 'pin',
      label: 'Tọa độ',
      dataKey: 'coordinates',
      exampleValue: '21.028511, 105.804817'
    },
    {
      icon: 'pin',
      label: 'Địa chỉ',
      dataKey: 'location',
      exampleValue: '7 Hồ Thiền Quang, Nguyễn Du, Hai Bà Trưng, Hà Nội'
    },
    {
      icon: 'speedometer2',
      label: 'Vận tốc',
      dataKey: 'speed_gps',
      exampleValue: '0 km/h'
    },
    {
      icon: 'maxSpeed',
      label: 'Vận tốc tối đa',
      dataKey: 'max_speed',
      exampleValue: '0 km/h'
    },
    {
      icon: 'direction',
      label: 'Km trong ngày',
      dataKey: 'daily_distance',
      exampleValue: '500 km'
    },
    {
      icon: 'parked',
      label: 'Thời gian dừng đỗ',
      dataKey: 'stop_duration',
      exampleValue: '03h23p'
    },
    {
      icon: 'direction',
      label: 'Km tích lũy',
      dataKey: 'total_distance',
      exampleValue: '5000 km'
    },
    {
      icon: 'battery',
      label: 'Điện áp',
      dataKey: 'battery',
      exampleValue: '12.5 V'
    },
    {
      icon: 'device',
      label: 'Cảm biến nhiên liệu:',
      dataKey: 'activity_chart',
      exampleValue: ''
    }
  ],
  [
    {
      icon: 'device',
      label: 'Loại thiết bị',
      dataKey: 'device_type',
      exampleValue: 'VGPS_MOTO4G'
    },
    {
      icon: 'serial',
      label: 'Serial thiết bị',
      dataKey: 'serial',
      exampleValue: 'ABC123'
    },
    {
      icon: 'fw_version',
      label: 'Phiên bản HW / FW',
      dataKey: 'firmware_version',
      exampleValue: '1.0.0'
    },
    {
      icon: 'sim',
      label: 'Imei sim',
      dataKey: 'imei_sim',
      exampleValue: '0989982456'
    },
    {
      icon: 'phone',
      label: 'SĐT Sim',
      dataKey: 'sim',
      exampleValue: '0989982456'
    },
    {
      icon: 'network',
      label: 'Nhà mạng',
      dataKey: 'network_operator',
      exampleValue: 'Vinaphone'
    },
    {
      icon: 'register_package_day',
      label: 'Ngày kích hoạt',
      dataKey: 'active_at',
      exampleValue: '14/07/2023'
    },
    {
      icon: 'user',
      label: 'Tên đại lý',
      dataKey: 'agency_name',
      exampleValue: 'Vntech24h'
    },
    {
      icon: 'oil_sensor',
      label: 'Giá trị CB nhiên liệu',
      dataKey: 'fuel_sensor_val'
    },
    {
      icon: 'level',
      label: '4G signal / Vệ tinh',
      dataKey: 'gsm_level',
      exampleValue: '3'
    },
  ]
];

export const INFOR_MAG4G = [
  [
    {
      icon: 'car',
      label: 'Biển số',
      dataKey: 'license_plate',
      exampleValue: '30H99888'
    },
    {
      icon: 'user',
      label: 'Tên gợi nhớ',
      dataKey: 'custom_name',
      exampleValue: 'Tên gợi nhớ'
    },
    {
      icon: 'clock',
      label: 'Thời gian',
      dataKey: 'created_at',
      exampleValue: '20:45 30/04/2021'
    },
    {
      icon: 'pin',
      label: 'Tọa độ',
      dataKey: 'coordinates',
      exampleValue: '21.028511, 105.804817'
    },
    {
      icon: 'pin',
      label: 'Địa chỉ',
      dataKey: 'location',
      exampleValue: '7 Hồ Thiền Quang, Nguyễn Du, Hai Bà Trưng, Hà Nội'
    },
    {
      icon: 'speedometer2',
      label: 'Vận tốc',
      dataKey: 'speed_gps',
      exampleValue: '0 km/h'
    },
    {
      icon: 'maxSpeed',
      label: 'Vận tốc tối đa',
      dataKey: 'max_speed',
      exampleValue: '0 km/h'
    },
    {
      icon: 'direction',
      label: 'Km trong ngày',
      dataKey: 'daily_distance',
      exampleValue: '500 km'
    },
    {
      icon: 'direction',
      label: 'Km tích lũy',
      dataKey: 'total_distance',
      exampleValue: '5000 km'
    },
    {
      icon: 'parked',
      label: 'Thời gian dừng đỗ',
      dataKey: 'stop_duration',
      exampleValue: '03h23p'
    },
    {
      icon: 'battery',
      label: 'Pin',
      dataKey: 'battery',
      exampleValue: '12.5 V'
    },
    {
      icon: 'device',
      label: 'Cảm biến nhiên liệu:',
      dataKey: 'activity_chart',
      exampleValue: ''
    }
  ],
  [
    {
      icon: 'device',
      label: 'Loại thiết bị',
      dataKey: 'device_type',
      exampleValue: 'VGPS_MOTO4G'
    },
    {
      icon: 'serial',
      label: 'Serial thiết bị',
      dataKey: 'serial',
      exampleValue: 'ABC123'
    },
    {
      icon: 'fw_version',
      label: 'Phiên bản HW / FW',
      dataKey: 'firmware_version',
      exampleValue: '1.0.0'
    },
    {
      icon: 'sim',
      label: 'Imei sim',
      dataKey: 'imei_sim',
      exampleValue: '0989982456'
    },
    {
      icon: 'phone',
      label: 'SĐT Sim',
      dataKey: 'sim',
      exampleValue: '0989982456'
    },
    {
      icon: 'network',
      label: 'Nhà mạng',
      dataKey: 'network_operator',
      exampleValue: 'Vinaphone'
    },
    {
      icon: 'register_package_day',
      label: 'Ngày kích hoạt',
      dataKey: 'active_at',
      exampleValue: '14/07/2023'
    },
    {
      icon: 'user',
      label: 'Tên đại lý',
      dataKey: 'agency_name',
      exampleValue: 'Vntech24h'
    },
    {
      icon: 'oil_sensor',
      label: 'Giá trị CB nhiên liệu',
      dataKey: 'fuel_sensor_val'
    },
    {
      icon: 'level',
      label: '4G signal / Vệ tinh',
      dataKey: 'gsm_level',
      exampleValue: '3'
    },
    {
      icon: 'acquy',
      label: 'Trạng thái sạc',
      dataKey: 'charge_status',
      exampleValue: 'Đang sạc'
    }
  ]
];
